import * as React from 'react';
import * as styled from './styled';
import {Draggable} from 'react-beautiful-dnd';
import {WordProps} from './types';

/**
 * The word.
 * @param {WordProps} props
 * @return {React.ReactElement<WordProps>}
 * @constructor
 */
export default function Word(
    props: WordProps,
): React.ReactElement<WordProps> {
  return (
    <Draggable draggableId={props.children} index={props.index}>
      {(provided) => (
        <styled.Wrapper
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {props.children}
        </styled.Wrapper>
      )}
    </Draggable>
  );
}
